import React from "react";
import { SideOverlay } from "../side-overlay";
import { EnquiryDetailSections } from "./EnquiryDetailPanel";
import { displayText, type EnquiryRow } from "./enquiry-helpers";

type EnquiryDetailDrawerProps = {
    row: EnquiryRow | null;
    onClose: () => void;
    refreshTable: () => void;
};

export const EnquiryDetailDrawer = ({ row, onClose, refreshTable }: EnquiryDetailDrawerProps) => (
    <SideOverlay
        show={Boolean(row)}
        onClose={onClose}
        title={row ? `Enquiry — ${displayText(row.name)}` : "Enquiry details"}
        size="medium"
    >
        {row ? <EnquiryDetailSections row={row} refreshTable={refreshTable} /> : null}
    </SideOverlay>
);
